import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="w-full py-8" style={{
      backgroundColor: '#C5DDD1'
    }} data-id="element-16">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-17">
          <p className="text-sm mb-4" style={{
          color: '#1A1A1A'
        }} data-id="element-18">
            © 2026 Cero Inflamación en 72H. Todos los derechos reservados.
          </p>

          <div className="flex items-center justify-center gap-2 text-sm" data-id="element-19">
            <button onClick={() => setActiveModal('privacy')} className="transition-colors hover:underline" style={{
            color: '#C9A96E'
          }} data-id="element-20">
              Política de Privacidad
            </button>
            <span style={{
            color: '#1A1A1A'
          }} data-id="element-21">
              •
            </span>
            <button onClick={() => setActiveModal('terms')} className="transition-colors hover:underline" style={{
            color: '#C9A96E'
          }} data-id="element-22">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-23">
        <div className="space-y-6" data-id="element-24">
          <section data-id="element-25">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-26">
              Información que Recopilamos
            </h3>
            <p data-id="element-27">
              Recopilamos únicamente la información necesaria para procesar tu
              compra y entregarte el producto digital. Esto incluye tu nombre,
              dirección de correo electrónico y datos de pago procesados de
              forma segura a través de nuestra plataforma de pagos.
            </p>
          </section>

          <section data-id="element-28">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-29">
              Uso de la Información
            </h3>
            <p data-id="element-30">Utilizamos tu información exclusivamente para:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-31">
              <li data-id="element-32">Procesar y completar tu compra</li>
              <li data-id="element-33">Enviarte el producto digital adquirido</li>
              <li data-id="element-34">Comunicarnos contigo sobre tu pedido si es necesario</li>
              <li data-id="element-35">Mejorar nuestros productos y servicios</li>
            </ul>
          </section>

          <section data-id="element-36">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-37">
              Protección de Datos
            </h3>
            <p data-id="element-38">
              Tu información personal está protegida mediante encriptación de
              nivel bancario. No compartimos, vendemos ni alquilamos tu
              información personal a terceros bajo ninguna circunstancia.
            </p>
          </section>

          <section data-id="element-39">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-40">
              Uso de Cookies
            </h3>
            <p data-id="element-41">
              Utilizamos cookies básicas de navegación para mejorar tu
              experiencia en nuestro sitio. Estas cookies nos ayudan a entender
              cómo interactúas con nuestra página y a optimizar su
              funcionamiento.
            </p>
          </section>

          <section data-id="element-42">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-43">
              Tus Derechos
            </h3>
            <p data-id="element-44">Tienes derecho a:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-45">
              <li data-id="element-46">Acceder a la información que tenemos sobre ti</li>
              <li data-id="element-47">Solicitar la rectificación de datos incorrectos</li>
              <li data-id="element-48">Solicitar la eliminación de tus datos personales</li>
              <li data-id="element-49">Retirar tu consentimiento en cualquier momento</li>
            </ul>
          </section>

          <section data-id="element-50">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-51">
              Modificaciones a Esta Política
            </h3>
            <p data-id="element-52">
              Nos reservamos el derecho de actualizar esta política de
              privacidad en cualquier momento. Te notificaremos sobre cambios
              significativos publicando la nueva política en esta página.
            </p>
          </section>

          <p className="text-sm italic mt-6" style={{
          color: '#6B6B6B'
        }} data-id="element-53">
            Última actualización: Marzo 2026
          </p>
        </div>
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-54">
        <div className="space-y-6" data-id="element-55">
          <section data-id="element-56">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-57">
              Aceptación de los Términos
            </h3>
            <p data-id="element-58">
              Al realizar una compra en nuestro sitio, aceptas estos términos y
              condiciones en su totalidad. Si no estás de acuerdo con alguna
              parte de estos términos, te pedimos que no realices la compra.
            </p>
          </section>

          <section data-id="element-59">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-60">
              Producto Digital
            </h3>
            <p data-id="element-61">
              El producto "Cero Inflamación en 72H" es un libro electrónico
              (eBook) en formato PDF. Una vez completada la compra, recibirás
              acceso inmediato al material a través del correo electrónico
              proporcionado durante el proceso de pago.
            </p>
          </section>

          <section data-id="element-62">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-63">
              Licencia de Uso Personal
            </h3>
            <p data-id="element-64">
              Al adquirir este producto, obtienes una licencia personal e
              intransferible para:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-65">
              <li data-id="element-66">
                Descargar y almacenar el contenido en tus dispositivos
                personales
              </li>
              <li data-id="element-67">Utilizar el material para tu beneficio personal</li>
            </ul>
            <p className="mt-2" data-id="element-68">
              Queda prohibida la redistribución, reventa, copia o compartición
              del material con terceros.
            </p>
          </section>

          <section data-id="element-69">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-70">
              Política de Reembolso
            </h3>
            <p data-id="element-71">
              Debido a la naturaleza digital del producto y su entrega
              instantánea, no ofrecemos reembolsos una vez que el contenido ha
              sido descargado o accedido. Te recomendamos leer cuidadosamente la
              descripción del producto antes de realizar tu compra.
            </p>
          </section>

          <section data-id="element-72">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-73">
              Propiedad Intelectual
            </h3>
            <p data-id="element-74">
              Todo el contenido del producto, incluyendo textos, gráficos,
              imágenes y diseño, está protegido por derechos de autor. La compra
              del producto no transfiere ningún derecho de propiedad intelectual
              al comprador.
            </p>
          </section>

          <section data-id="element-75">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-76">
              Limitación de Responsabilidad
            </h3>
            <p data-id="element-77">
              El contenido de este producto es únicamente informativo y
              educativo. No constituye consejo médico, nutricional o de salud
              profesional. Antes de realizar cambios significativos en tu
              alimentación o estilo de vida, consulta con un profesional de la
              salud calificado.
            </p>
            <p className="mt-2" data-id="element-78">
              No nos hacemos responsables de los resultados individuales, ya que
              estos pueden variar según cada persona.
            </p>
          </section>

          <section data-id="element-79">
            <h3 className="text-lg font-semibold mb-2" style={{
            color: '#1A1A1A'
          }} data-id="element-80">
              Modificaciones a los Términos
            </h3>
            <p data-id="element-81">
              Nos reservamos el derecho de modificar estos términos y
              condiciones en cualquier momento. Los cambios entrarán en vigor
              inmediatamente después de su publicación en esta página.
            </p>
          </section>

          <p className="text-sm italic mt-6" style={{
          color: '#6B6B6B'
        }} data-id="element-82">
            Última actualización: Marzo 2026
          </p>
        </div>
      </LegalModal>
    </>;
}